import React, { createContext, useState, useEffect, useContext } from 'react';
import { api } from '../utils/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkLoggedIn = async () => {
      try {
        const data = await api.get('/users/me');
        setUser(data);
      } catch (error) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkLoggedIn();
  }, []);

  const login = async (username, password) => {
    const data = await api.post('/users/login', { username, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post('/users/logout', {});
    } catch (error) {
      console.error('Logout failed', error);
    }
    setUser(null);
    api.clearCache();
  };

  const value = {
    user,
    login,
    logout,
    loading,
    isAdmin: user && (user.role === 'admin' || user.role === 'superAdmin'),
    isSuperAdmin: user && user.role === 'superAdmin',
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
